import React from "react";
import "./welcomeLealtad.css";
import { FaFaceSmileBeam } from "react-icons/fa6";

const WelcomeLealtad = ({ data }) => {
  return (
    <div className="boxwelcomelealtad">
      <div>
        <FaFaceSmileBeam className="iconnotbilllealtad" />
      </div>
      <div className="boxtittlebilllealtad">
        <p className="tittlenotdatabilllealtad">
          ¡Hola, {data.name ? data.name : "usuario"}!
        </p>
      </div>
      <div className="boxexplainnotdatabilllealtad">
        <p className="explainotdatabilllealtad">Bienvenido al sistema</p>
      </div>
    </div>
  );
};

export default WelcomeLealtad;
